var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-top"}},[(_vm.visible)?_c('div',{staticClass:"top-tip",class:[_vm.typeClass, _vm.customClass],attrs:{"role":"alert"}},[_c('span',{staticClass:"top-tip__content"},[_vm._v(_vm._s(_vm.message))]),(_vm.showClose)?_c('button',{staticClass:"top-tip__close",on:{"click":_vm.close}},[_vm._v("×")]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }